import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
export function PromoBar() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <div className="sticky top-0 z-50 border-b border-ink/60 bg-ink text-cream" data-id="element-190" data-mp="8bib9jbsv6r1">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-2 px-5 py-2.5 text-center sm:flex-row sm:justify-between sm:text-left" data-id="element-191" data-mp="3h4cr81ucji5">
        <p className="text-[13px] leading-snug text-cream/85" data-id="element-192" data-mp="3qneoupm4lqo6">
          <span className="font-semibold text-cream" data-id="element-193" data-mp="3qopxb2qinmlm">Promo:</span> llevate el pack de 6 volúmenes
          + 6 bonos gratis con 60% de descuento —{' '}
          <span className="font-semibold text-cream" data-id="element-194" data-mp="3gop8x2dsigak">solo $27.990</span>. La oferta termina esta
          noche.
        </p>
        <p className="flex shrink-0 items-center gap-2 text-[11px] font-semibold uppercase tracking-eyebrow" data-id="element-195" data-mp="3brfm7uhsciqf">
          <span className="text-cream/60" data-id="element-196" data-mp="1exc6ql37imi7">Termina en</span>
          <span className="rounded-md bg-accent px-2.5 py-1 font-sans text-[13px] tracking-normal tabular-nums text-white" data-id="element-197" data-mp="19y9clvorm0p0">
            {hours}:{minutes}:{seconds}
          </span>
        </p>
      </div>
    </div>;
}